export enum CognitoCustomerRoute {
  SIGN_IN = '/v2/auth/sign-in',
  SIGN_UP = '/v2/auth/sign-up',
  FORGOT = '/v2/auth/forgot-password',
  RESET = '/v2/auth/confirm-forgot-password',
  OTP_VERIFY = '/v2/auth/verify-otp',
  OTP_RESEND = '/v2/auth/resend-otp',
  GOOGLE_AUTH_COMPLETE = '/v2/auth/google-sign-in/complete',
  CURRENT_USER = '/v2/customers/token',
}

export enum OtpPurpose {
  SIGN_IN = 'SIGN_IN',
}

export enum SignInAuthChallenge {
  PASSWORD = 'PASSWORD',
}
